import React from 'react';
import axiosInstance from '../utils/axiosSetup.js';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';


const UpdateStatusComponent = ({ url, id, fetchData, status }) => {
    const updateStatus = async ({change_status}) => {
        const isConfirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to change status!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '&nbsp;&nbsp;&nbsp; Yes &nbsp;&nbsp;&nbsp;'
        }).then((result) => {
            return result.isConfirmed
        });

        if(!isConfirm){
            return;
        }

        axiosInstance.post(`${process.env.REACT_APP_API_URL}/${url}/${id}`,{
                status: change_status,
            })
            .then(({data})=>{
                Swal.fire({
                    icon:"success",
                    text:data.message
                });
                fetchData();
            }).catch(({response:{data}})=>{
                Swal.fire({
                    text:data.message,
                    icon:"error"
                });
            });
    };

    return (
        <div className="dropdown action-label">
            <Link className="btn btn-white btn-sm btn-rounded dropdown-toggle" to="#" data-bs-toggle="dropdown" aria-expanded="false">
                {status === '1' &&
                    <><i className="fa-regular fa-circle-dot text-success"></i> Active</>
                }
                {status === '0' &&
                    <><i className="fa-regular fa-circle-dot text-danger"></i> Inactive</>
                }
            </Link>
            <div className="dropdown-menu dropdown-menu-right">                                                                        
                {status !== '0' &&
                    <Link className="dropdown-item" to="#" onClick={() => updateStatus({change_status: '0' })}>
                        <i className="fa-regular fa-circle-dot text-danger"></i> Inactive
                    </Link>
                }
                {status !== '1' &&
                    <Link className="dropdown-item" to="#" onClick={() => updateStatus({change_status: '1' })}>
                        <i className="fa-regular fa-circle-dot text-success"></i> Active
                    </Link>
                }
            </div>
        </div>
    );
};

export default UpdateStatusComponent;
